import { datadogLogs } from '@datadog/browser-logs';

import { CollectibleInventoryItem, User } from '@bonusly/who-am-i';

export function getActiveCollectibleItem(user: User | undefined): CollectibleInventoryItem | undefined {
	const inventory = user?.collectible_inventory;
	if (!Array.isArray(inventory)) {
		// Log only when we received an unexpected value (truthy but not array) - helps debug source
		if (inventory !== undefined && inventory !== null) {
			datadogLogs.logger.warn('[CollectibleInventory] user.collectible_inventory is not an array', {
				userId: user?.id,
				collectibleInventoryValue: inventory,
				collectibleInventoryType: typeof inventory,
				collectibleInventoryJson: JSON.stringify(inventory),
			});
		}
		return undefined;
	}
	return inventory.find((item) => item.remaining_uses > 0);
}
